// Environment configuration utility
// Supports both build-time (process.env) and runtime (window._env_) environment variables

const getEnv = (key, defaultValue = '') => {
  // For K8s deployment, use runtime config from window._env_
  if (window._env_ && window._env_[key]) {
    return window._env_[key];
  }
  
  // Fallback to build-time environment variables for local development
  if (process.env[key]) {
    return process.env[key];
  }
  
  // Use default value if neither is available
  return defaultValue;
};

export const config = {
  BACKEND_URL: getEnv('REACT_APP_BACKEND_URL', 'http://localhost:8001'),
};

export default config;
